import AspApi from "api/ApiConfig";

// broadcast list based on start and end endDate
export const broadcastList = async (brandId, startDate, endDate) => {
  const res = await AspApi.get(
    `/api/v1/svc/campaign_broadcast/broadcasts/calendar?brand_id=${brandId}&start_date=${startDate}&end_date=${endDate}`
  );
  return res;
};

// recent broadcast performance (metrics)
export const broadcastPerformance = async (
  brandId,
  startDate,
  endDate,
  recentCount
) => {
  const params = recentCount
    ? `recent_broadcast_count=${recentCount}`
    : `start_date=${startDate}&end_date=${endDate}`;
  const res = await AspApi.get(
    `/api/v1/svc/campaign_broadcast/broadcasts/broadcast_performance?brand_id=${brandId}&${params}`
  );
  return res;
};
